import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  FilterFlyoutIconName,
  Icon,
  SIZE,
  SPACING,
  desktopAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const StoryProductStreamEmpty: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Wrapper data-testid="StoryProductStreamEmpty">
      <Content>
        <IconWrapper>
          <Icon asset={FilterFlyoutIconName.Shirt} size="S" />
        </IconWrapper>
        <Title>{t('Nothing here yet')}</Title>
        <Subtitle>
          {t("We're bringing the latest styles to your screen.")}
        </Subtitle>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: ${SPACING['Y.Xl6']} ${SPACING['X.Lg']} ${SPACING['Y.Xl4']};

  ${desktopAndUpLinaria(`
    background-color: ${COLORS['Grey.Shade100']};
  `)}
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING['Y.Md']};

  ${desktopAndUpLinaria(`
    padding: ${SIZE.U7};
    max-width: 360px;
    margin: 0 auto;
  `)}
`;

const IconWrapper = styled.div`
  padding: ${SPACING['Y.Md']};
`;

const Title = styled.p`
  margin: 0;
  font-size: ${FONT_SIZES.px18};
  font-weight: ${FONT_WEIGHTS.w500};
  line-height: ${FONT_SIZES.px24};
  text-align: center;
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: ${FONT_SIZES.px16};
  line-height: ${FONT_SIZES.px24};
  color: ${COLORS['Grey.Shade500']};
  text-align: center;
`;
